var productId = {
	"CARDS 30 DIAS/30 DICAS PLASTIC FREE": "39381274951795",
	"LATINHA PRATEADA": "32117039562867",
	"LATINHA ROSA": "32117039497331",
	"BASE ZIG-ZAG BRANCA": "31947633197171",
	"BASE ZIG-ZAG CINZA": "31947633557619",
	"EMBALAGEM PARA PRESENTE": "39604233535603",
	"SHAMPOO SOLIDO NUTRITIVO": "39723607490675",
	"BOLSINHA REUTILIZAVEL - INTIMO": "39718494797939",
	"BOLSINHA REUTILIZAVEL - KIDS": "39723598446707",
	"BOLSINHA REUTILIZAVEL - CINZA": "39724174639219",
};

let brindes = [
	// { productId: productId["SHAMPOO SOLIDO NUTRITIVO"], priceAddBrinde: 12000, productDependente: [], label: "shampoo nutritivo", quantity: 0 },
	// { productId: productId["BOLSINHA REUTILIZAVEL - INTIMO"], priceAddBrinde: 0, productDependente: [39512734531699, 39640366022771], label: "bolsinha reutilizável - íntimo", quantity: 0 },
	// { productId: productId["BOLSINHA REUTILIZAVEL - KIDS"], priceAddBrinde: 0, productDependente: [39471471526003, 39626977902707, 39471471427699, 39626972987507], label: "bolsinha reutilizável - kids", quantity: 0 },
	// { productId: productId["BOLSINHA REUTILIZAVEL - CINZA"], priceAddBrinde: 0, productDependente: [39471472083059, 39626956406899, 39471471427699, 39626972987507], label: "bolsinha reutilizável - cinza", quantity: 0 },
	// { productId: productId["LATINHA ROSA"], priceAddBrinde: 20000, label: "latinha", quantity: 0 },
];

brindes = brindes.sort(function (a, b) {
	return a.priceAddBrinde - b.priceAddBrinde;
});

var usebobBrinde = {
	totalPrice: 0,
	cartItems: [],
	qtdPackagingAdd: 0,
	valueAddBrindeCurrent: 12000,
	valueRemoveBrindeCurrent: 0,

	qtdPackagingNext: 1,
	valueAddBrindeNext: 24000,
	lastSubtotal: 0,

	handleBarStatus() {
		const cartAside = document.querySelector("#sidebar-cart");
		const widthCartAside = cartAside.offsetWidth;

		const wrapperProgress = document.querySelector(
			".e-usebob-bar-status__progress"
		);
		wrapperProgress.style.width = widthCartAside + "px";

		const barStatusMessagePink = document.querySelector(
			".e-usebob-bar-status__message .e-message-pink"
		);
		const barStatusMessageWhite = document.querySelector(
			".e-usebob-bar-status__message .e-message-white"
		);

		const barProgress = document.querySelector(
			".e-usebob-bar-status__container-messages [data-progress]"
		);
		const containerProgress = document.querySelector(
			".e-usebob-bar-status__container-progress"
		);

		const priceAddGift = 5500;
		const priceFreeShipping = 5500;

		if (priceAddGift < priceFreeShipping) {
			setTimeout(() => {
				let newValue;
				const descountValueElement =
					document.querySelector(".sc_code-info .money.mw-price") || 0;
				if (descountValueElement != 0) {
					const descountValueString = descountValueElement.innerHTML
						.replace("$", "")
						.replace(".", "");
					const descountValue = parseInt(descountValueString) || 0;
					newValue = usebobMinicart.totalPrice - descountValue;
				} else {
					newValue = usebobMinicart.totalPrice;
				}
				if (priceFreeShipping - newValue <= 0) {
					barStatusMessagePink.textContent = `YOU GOT FREE SHIPPING AND A SHAMPOO BAR ON THIS ORDER ♡`;
					barStatusMessageWhite.textContent = `YOU GOT FREE SHIPPING AND A SHAMPOO BAR ON THIS ORDER ♡`;
					const calcProgress = (newValue / priceFreeShipping) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;
				} else if (priceAddGift - newValue <= 0) {
					barStatusMessagePink.textContent = `YOU GOT A SHAMPOO BAR ON THIS ORDER ♡`;
					barStatusMessageWhite.textContent = `YOU GOT A SHAMPOO BAR ON THIS ORDER ♡`;
					const calcProgress = (newValue / priceAddGift) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;

					setTimeout(() => {
						const calcPrecoFalta = ((priceFreeShipping - newValue) / 100)
							.toFixed(2)
							.replace(".", ",");
						barStatusMessagePink.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;
						barStatusMessageWhite.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;

						const calcProgress = (newValue / priceFreeShipping) * 100;
						barProgress.style.width = `${calcProgress}%`;
						containerProgress.style.maxWidth = `${calcProgress}%`;
					}, 1500);
				} else {
					const calcPrecoFalta = ((priceAddGift - newValue) / 100)
						.toFixed(2)
						.replace(".", ",");
					barStatusMessagePink.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET A SHAMPOO BAR`;
					barStatusMessageWhite.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET A SHAMPOO BAR`;
					const calcProgress = (newValue / priceAddGift) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;
				}
			}, 1500);
		} else {
			setTimeout(() => {
				let newValue;
				const descountValueElement =
					document.querySelector(".sc_code-info .money.mw-price") || 0;
				if (descountValueElement != 0) {
					const descountValueString = descountValueElement.innerHTML
						.replace("$", "")
						.replace(".", "");
					const descountValue = parseInt(descountValueString) || 0;
					newValue = usebobMinicart.totalPrice - descountValue;
				} else {
					newValue = usebobMinicart.totalPrice;
				}

				if (priceAddGift - newValue <= 0) {
					barStatusMessagePink.textContent = `YOU GOT FREE SHIPPING ON THIS ORDER ♡`;
					barStatusMessageWhite.textContent = `YOU GOT FREE SHIPPING ON THIS ORDER ♡`;
					const calcProgress = (newValue / priceAddGift) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;
				} else if (priceFreeShipping - newValue <= 0) {
					barStatusMessagePink.textContent = `YOU GOT FREE SHIPPING ON THIS ORDER ♡`;
					barStatusMessageWhite.textContent = `YOU GOT FREE SHIPPING ON THIS ORDER ♡`;
					const calcProgress = (newValue / priceFreeShipping) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;

					setTimeout(() => {
						const calcPrecoFalta = ((priceAddGift - newValue) / 100)
							.toFixed(2)
							.replace(".", ",");
						barStatusMessagePink.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;
						barStatusMessageWhite.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;
						const calcProgress = (newValue / priceAddGift) * 100;
						barProgress.style.width = `${calcProgress}%`;
						containerProgress.style.maxWidth = `${calcProgress}%`;
					}, 1500);
				} else {
					const calcPrecoFalta = ((priceFreeShipping - newValue) / 100)
						.toFixed(2)
						.replace(".", ",");
					barStatusMessagePink.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;
					barStatusMessageWhite.textContent = `BUY $${calcPrecoFalta} OR MORE AND GET FREE SHIPPING ♡ `;
					const calcProgress = (newValue / priceFreeShipping) * 100;
					barProgress.style.width = `${calcProgress}%`;
					containerProgress.style.maxWidth = `${calcProgress}%`;
				}
			}, 1500);
		}
	},



	handleBarStatusEmbalagem() {
		document.dispatchEvent(new CustomEvent("theme:loading:start"));

		const valueAddBrinde = 12500;
		const barStatusMessage = document.querySelector(
			".e-usebob-bar-status__message"
		);

		// console.log("Último total ", usebobBrinde.lastSubtotal);
		// console.log("Atual total ", usebobBrinde.totalPrice);
		// console.log("Valor do brinde ", usebobBrinde.valueAddBrindeCurrent);

		if (
			usebobBrinde.lastSubtotal < usebobBrinde.totalPrice &&
			usebobBrinde.totalPrice >= usebobBrinde.valueAddBrindeCurrent
		) {
			// mensagem que foi adicionado ao carrinho o brinde
			barStatusMessage.textContent =
				usebobBrinde.qtdPackagingNext + " embalagem foi adicionada ao carrinho"; // '1 embalagem foi adicionada ao carrinho'
		} else if (
			usebobBrinde.lastSubtotal > usebobBrinde.totalPrice &&
			usebobBrinde.totalPrice < usebobBrinde.valueRemoveBrindeCurrent
		) {
			// mensagem que foi adicionado ao carrinho o brinde
			barStatusMessage.textContent = "removido 1 embalagem do carrinho"; // '1 embalagem foi adicionada ao carrinho'
		}

		setTimeout(function () {
			usebobBrinde.qtdPackagingAdd = parseInt(
				usebobBrinde.totalPrice / valueAddBrinde
			);
			if (usebobBrinde.totalPrice == 0) {
				usebobBrinde.valueAddBrindeCurrent = 12500;
			} else {
				usebobBrinde.valueAddBrindeCurrent =
					Math.ceil(usebobBrinde.totalPrice / valueAddBrinde) * valueAddBrinde;
			}
			usebobBrinde.valueRemoveBrindeCurrent =
				Math.floor(usebobBrinde.totalPrice / valueAddBrinde) * valueAddBrinde;
			usebobBrinde.qtdPackagingNext =
				parseInt(usebobBrinde.totalPrice / valueAddBrinde) + 1;
			usebobBrinde.valueAddBrindeNext =
				usebobBrinde.qtdPackagingNext * valueAddBrinde;

			// Atualizar mensagem para o usuário
			const calcPrecoFalta = (
				(usebobBrinde.valueAddBrindeNext - usebobBrinde.totalPrice) /
				100
			)
				.toFixed(2)
				.replace(".", ",");

			if (usebobBrinde.qtdPackagingNext == 1) {
				barStatusMessage.textContent = `faltam R$ ${calcPrecoFalta} para você ganhar ${usebobBrinde.qtdPackagingNext} embalagem`;
			} else {
				barStatusMessage.textContent = `faltam R$ ${calcPrecoFalta} para você ganhar ${usebobBrinde.qtdPackagingNext} embalagens`;
			}

			const barProgress = document.querySelector("[data-progress]");
			const calcProgress =
				(usebobBrinde.totalPrice / usebobBrinde.valueAddBrindeNext) * 100;
			barProgress.style.width = `${calcProgress}%`;

			document.dispatchEvent(new CustomEvent("theme:loading:end"));

			usebobBrinde.lastSubtotal = usebobBrinde.totalPrice;
		}, 800);
	},

	handleRemoveBrindesEmCache() {
		// REMOVER OS BRINDES DO CARRINHO QUANDO A PROMOÇÃO JÁ ACABOU
		if (
			document.querySelector(
				`[href*='/cart/change?quantity=0&id=${productId["CARDS 30 DIAS/30 DICAS PLASTIC FREE"]}']`
			)
		) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(
					`[href*='/cart/change?quantity=0&id=${productId["CARDS 30 DIAS/30 DICAS PLASTIC FREE"]}']`
				)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: { variant: [], quantity: 1 },
				})
			);
		} else if (
			document.querySelector(
				`[href*='/cart/change?quantity=0&id=${productId["BASE ZIG-ZAG CINZA"]}']`
			)
		) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(
					`[href*='/cart/change?quantity=0&id=${productId["BASE ZIG-ZAG CINZA"]}']`
				)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: { variant: [], quantity: 1 },
				})
			);
		} else if (
			document.querySelector(
				`[href*='/cart/change?quantity=0&id=${productId["LATINHA ROSA"]}']`
			)
		) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(
					`[href*='/cart/change?quantity=0&id=${productId["LATINHA ROSA"]}']`
				)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: { variant: [], quantity: 1 },
				})
			);
		} else if (
			document.querySelector(
				`[href*='/cart/change?quantity=0&id=${productId["EMBALAGEM PARA PRESENTE"]}']`
			)
		) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(
					`[href*='/cart/change?quantity=0&id=${productId["EMBALAGEM PARA PRESENTE"]}']`
				)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: { variant: [], quantity: 1 },
				})
			);
		}
	},

	handleRemoveBrindesEmSolo() {
		if (usebobBrinde.cartItems.length > 0 && usebobBrinde.totalPrice == 0) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			fetch("/cart/clear.js", {
				method: "POST",
			})
				.then((response) => response.json())
				.then((data) => {
					console.log(data);
					document.dispatchEvent(new CustomEvent("theme:loading:end"));
					document.dispatchEvent(
						new CustomEvent("product:added", {
							bubbles: true,
							detail: {
								variant: data.items,
								quantity: data.item_count,
							},
						})
					);
				})
				.catch((error) => {
					console.log(error);
					document.dispatchEvent(new CustomEvent("theme:loading:end"));
				});
		}
	},

	handleBrindeEmbalagem() {
		const valueAddBrinde = 12500;

		if (usebobBrinde.cartItems.length > 0) {
			usebobBrinde.cartItems.forEach(function (item) {
				if (item.id == "39604233535603") {
					usebobBrinde.qtdPackagingAdd = item.quantity;
				}
			});
		}

		// console.log(usebobBrinde.qtdPackagingAdd);
		const newQuantity = parseInt(usebobBrinde.totalPrice / valueAddBrinde);

		const items = {
			39604233535603: newQuantity,
		};

		if (usebobBrinde.qtdPackagingAdd != newQuantity) {
			usebobBrinde.setItemBrindeEmbalagem(items);
		}

		usebobBrinde.qtdPackagingAdd = newQuantity;

		if (usebobBrinde.qtdPackagingAdd === 0) {
			// const item = {
			//     "39604233535603": newQuantity
			// }
			// usebobBrinde.setItemBrindeEmbalagem(item);
		}
	},

	async handleCart() {
		for (let j = 0; j < brindes.length; j++) {
			const brinde = brindes[j];
			let contemItemBrindeNoCart = false;

			for (let i = 0; i < usebobBrinde.cartItems.length; i++) {
				const item = usebobBrinde.cartItems[i];

				if (item.id == brinde.productId) {
					contemItemBrindeNoCart = true;
					brindes[j].quantity = Number(item.quantity);
					// console.log(brindes[j].label, brindes[j].quantity);
				}
			}

			if (!contemItemBrindeNoCart) {
				brindes[j].quantity = 0;
			}
		}

		// console.log(brindes);

		const itemsAdd = [];
		const itemsRem = [];
		const itemsAjustarQuantity = [];

		for (let j = 0; j < brindes.length; j++) {
			const brinde = brindes[j];
			const brindeStatus = { quantity: 0 };

			for (let i = 0; i < usebobBrinde.cartItems.length; i++) {
				const item = usebobBrinde.cartItems[i];
				const contemItemDependenteNoCart = brinde.productDependente.includes(
					item.id
				);

				if (contemItemDependenteNoCart) {
					brindeStatus.productId = brinde.productId;
					brindeStatus.quantity = brindeStatus.quantity + item.quantity;
				}
			}

			// console.log(brindeStatus);

			if (brinde.quantity < brindeStatus.quantity && brinde.quantity == 0) {
				itemsAdd.push({
					productId: brinde.productId,
					quantity: brindeStatus.quantity - brinde.quantity,
				});
			}
		}

		for (let j = 0; j < brindes.length; j++) {
			const brinde = brindes[j];
			const brindeStatus = { quantity: 0 };

			let existProductIntimo = false;
			let existProductKids = false;

			for (let i = 0; i < usebobBrinde.cartItems.length; i++) {
				const item = usebobBrinde.cartItems[i];
				const contemItemDependenteNoCart = brinde.productDependente.includes(
					item.id
				);

				// console.log(brinde.label, item.title, item.id)

				if (contemItemDependenteNoCart) {
					existProductIntimo = true;
					existProductKids = true;
				}
			}

			if ((!existProductIntimo || !existProductKids) && brinde.quantity >= 1) {
				brindeStatus.productId = brinde.productId;
				brindeStatus.quantity = 0;
				itemsRem.push(brindeStatus);
			}

			// console.log(brindeStatus);
		}

		for (let j = 0; j < brindes.length; j++) {
			const brinde = brindes[j];
			const brindeStatus = { quantity: 0 };

			if (brinde.productDependente.length > 0) {
				for (let i = 0; i < usebobBrinde.cartItems.length; i++) {
					const item = usebobBrinde.cartItems[i];
					const contemItemDependenteNoCart = brinde.productDependente.includes(
						item.id
					);

					if (contemItemDependenteNoCart) {
						brindeStatus.productId = brinde.productId;
						brindeStatus.quantity = brindeStatus.quantity + item.quantity;
					}
				}

				// console.log(brindeStatus);

				if (brinde.quantity !== brindeStatus.quantity && brinde.quantity >= 0) {
					itemsAjustarQuantity.push({
						productId: brinde.productId,
						quantity: brindeStatus.quantity,
					});
				}
			} else {
				if (
					usebobBrinde.totalPrice >= brinde.priceAddBrinde &&
					brinde.quantity >= 2
				) {
					return brinde;
				}
			}
		}

		// const itemsAdd = brindes.filter(function(brinde) {

		//     if(brinde.productDependente.length > 0) {

		//         let updateQuantity = false;
		//         let existProductIntimo = false;
		//         let existProductKids = false;

		//         for(let i = 0; i < usebobBrinde.cartItems.length; i++) {
		//             const item = usebobBrinde.cartItems[i];

		//             if(brinde.productDependente.includes(item.id)) {
		//                 existProductIntimo = true;
		//                 existProductKids = true;
		//                 console.log(brinde.quantity, item.quantity);
		//                 if(brinde.quantity < item.quantity) {
		//                     brinde.quantity = item.quantity;
		//                     updateQuantity = true;
		//                 }
		//                 // console.log("Nome: ", item.title, "Dependente id: ", item.id)
		//                 // console.log("Brinde: ", brinde.label, "Quantity: ", brinde.quantity, "Tem item dependente no cart: ", brinde.productDependente.includes(item.id));
		//             }
		//         }

		//         if((existProductIntimo || existProductKids) && updateQuantity) {
		//             console.log("Brinde com produto dependente ", brinde)
		//             return brinde;
		//         }

		//     }
		//     else {
		//         if(usebobBrinde.totalPrice >= brinde.priceAddBrinde && brinde.quantity == 0) {
		//             return brinde;
		//         }
		//     }

		// })

		// const itemsRem = brindes.filter(function(brinde) {

		//     if(brinde.productDependente.length > 0) {

		//         let existProductIntimo = false;
		//         let existProductKids = false;

		//         for(let i = 0; i < usebobBrinde.cartItems.length; i++) {
		//             const item = usebobBrinde.cartItems[i];

		//             if(brinde.productDependente.includes(item.id)) {
		//                 existProductIntimo = true;
		//                 existProductKids = true;
		//                 // console.log("Nome: ", item.title, "Dependente id: ", item.id)
		//                 // console.log("Brinde: ", brinde.label, "Quantity: ", brinde.quantity, "Tem item dependente no cart: ", brinde.productDependente.includes(item.id));
		//             }

		//         }

		//         if((!existProductIntimo || !existProductKids) && brinde.quantity >= 1) {
		//             return brinde;
		//         }

		//         // console.log("Brinde com produto dependente ", brinde)

		//     }
		//     else {
		//         if(brinde.quantity >= 1 && usebobBrinde.totalPrice < brinde.priceAddBrinde) {
		//             return brinde;
		//         }
		//     }
		// })

		// const itemsAjustarQuantity = brindes.filter(function(brinde) {

		//     if(brinde.productDependente.length > 0) {

		//         for(let i = 0; i < usebobBrinde.cartItems.length; i++) {
		//             const item = usebobBrinde.cartItems[i];

		//             if(brinde.productDependente.includes(item.id) && brinde.quantity >= 2) {
		//                 return brinde;
		//             }
		//         }

		//     }
		//     else {
		//         if(usebobBrinde.totalPrice >= brinde.priceAddBrinde && brinde.quantity >= 2) {
		//             return brinde;
		//         }
		//     }
		// })

		// console.log("Produtos para adicionar", itemsAdd);
		// console.log("Produtos para remover", itemsRem);
		// console.log("Produtos para alterar quantidade", itemsAjustarQuantity);

		if (itemsAdd.length > 0) {
			// for(let i = 0; i < itemsAdd.length; i++) {

			//     for(let j = 0; j < brindes.length; j++) {
			//         if(itemsAdd[i].productId == brindes[j].productId) {
			//             // brindes[j].quantity = itemsAdd[i].quantity;
			//             // itemsAdd[i].quantity = 1;
			//         }
			//     }
			// }
			const items = itemsAdd.map(function (item) {
				return { id: item.productId, quantity: item.quantity };
			});

			// await usebobBrinde.setItemBrinde(items);
		}

		if (itemsRem.length > 0) {
			for (let i = 0; i < itemsRem.length; i++) {
				for (let j = 0; j < brindes.length; j++) {
					if (itemsRem[i].productId == brindes[j].productId) {
						// brindes[j].quantity = 0;
						// itemsRem[i].quantity = 0;
					}
				}
			}

			usebobBrinde.removeItemBrinde(itemsRem);
		}

		if (itemsAjustarQuantity.length > 0) {
			for (let i = 0; i < itemsAjustarQuantity.length; i++) {
				for (let j = 0; j < brindes.length; j++) {
					if (itemsAjustarQuantity[i].productId == brindes[j].productId) {
						// brindes[j].quantity = 1;
						// itemsAjustarQuantity[i].quantity = 1;
					}
				}
			}
			const items = itemsAjustarQuantity.reduce(function (obj, item) {
				obj[item.productId] = item.quantity;
				return obj;
			}, {});
			await usebobBrinde.updateItems(items);
		}
	},

	descountValue() {
		let descountValue = 0;
		setTimeout(() => {
			const descountValueElement =
				document.querySelector(".sc_code-info .money.mw-price") || 0;
			if (descountValueElement != 0) {
				const descountValueString = descountValueElement.innerHTML
					.replace("$", "")
					.replace(".", "");
				descountValue = parseInt(descountValueString);
			}
			usebobBrinde.canAddFreeProduct(descountValue);
		}, 500);
	},

	async canAddFreeProduct(descountValue) {
		if (usebobMinicart.totalPrice < 19900 + descountValue) {
			if (upsellSelectors.upsell) {
				// DESABILITANDO O CONTAINER DO UPSELL
				upsellSelectors.upsell.classList.remove("active");

				setTimeout(function () {
					upsellSelectors.upsellFeedback.classList.remove("active");
					upsellSelectors.containerUpsell.classList.remove("active");
				}, 200);
			}
		}

		const brindes = [
			{
				variantID: productId['LATINHA ROSA'],
				priceAddBrinde: 3500 + descountValue,
				quantity: 1,
				label: "latinha rosa",
				dependentProduct: [],
			}
		];

		const brindesOnlyRemove = [
			{
				variantID: productId["SHAMPOO DETOX"],
				priceAddBrinde: 12500 + descountValue,
				quantity: 0,
				label: "shampoo detox - brinde",
				dependentProduct: [],
			}
		];

		brindes.sort(function (a, b) {
			return a.priceAddBrinde - b.priceAddBrinde;
		});

		usebobBrindeBolsinha.updateQuantityOfFreeProducts(brindes);
		const updateProducts =
			usebobBrindeBolsinha.updateProductsWithQuantityChangesToCart(brindes);
		const removeProducts =
			usebobBrindeBolsinha.removeFreeProductsFromCart(brindes);

		brindesOnlyRemove.sort(function (a, b) {
			return a.priceAddBrinde - b.priceAddBrinde;
		});
		usebobBrindeBolsinha.updateQuantityOfFreeProducts(brindesOnlyRemove);
		const removeProducts2 =
			usebobBrindeBolsinha.removeFreeProductsFromCart(brindesOnlyRemove);

		updateProducts.then((data) => {
			if (data.length > 0) {
				data.forEach(function (brinde) {
					if (brinde.dependentProduct.length === 0) {
						brinde.quantity = 1;
					}
				});

				const objectUpdateProducts = data.reduce(function (
					objectProducts,
					brinde
				) {
					objectProducts[brinde.variantID] = brinde.quantity;
					return objectProducts;
				},
					{});

				setTimeout(() => {
					usebobMinicart.updateCartItems(objectUpdateProducts);
				}, 700);
			}
		});

		removeProducts.then((data) => {
			if (data.length > 0) {
				usebobMinicart.removeItemBrinde(removeProducts);
			}
		});

		removeProducts2.then((data) => {
			if (data.length > 0) {
				usebobMinicart.removeItemBrinde(removeProducts2);
			}
		});
	},

	async handleGift() {
		const response = await axios.get(`/cart.js`);
		const data = response.data;
		let hasShampoo = 0;
		let hasTin = 0;

		const shampoosToRemove = [
			'SH01-US-GIFT',
			'SH02-US-GIFT',
			'SH03-US-GIFT',
			'SH04-US-GIFT',
		]
		const tinsToRemove = [
			// 'LT01-US-GIFT',
			// 'LT02-US-GIFT',
			// 'LT03-US-GIFT',
			// 'LT04-US-GIFT',
		]

		data.items.forEach(item => {
			shampoosToRemove.forEach(gift => {
				if (item.sku == gift && item.properties.root == 'promoSelect') {
					hasShampoo = hasShampoo + 1;

					if (data.total_price < 9999999) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
					if (item.quantity > 1) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
					if (hasShampoo > 1) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
				}
			})

			tinsToRemove.forEach(gift => {
				if (item.sku == gift) {
					hasTin = hasTin + 1;

					if (data.total_price < 3500) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
					if (item.quantity > 1) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
					if (hasTin > 1) {
						utils.removeFromCart({ id: item.id.toString(), quantity: 0 })
					}
				}
			})
		})

	},

	async getItemsCart() {
		// console.log("getItemsCart");

		const response = await axios.get(`/cart.js`);
		const data = response.data;
		usebobBrinde.cartItems = data.items;
		usebobBrinde.qtdaItems = data.item_count;
		usebobBrinde.totalPrice = data.total_price;

		// HABILITAR SOMENTE QUANDO TIVER BRINDE PRA SER ADICIONADO E REMOVIDO DO CARRINHO
		// await usebobBrinde.handleCart();
		usebobBrinde.handleBarStatus();

		// UPSELL MINICART
		// if (usebobBrinde.qtdaItems != 0) { }
		// await upsellMinicart.init()

		// HABILITAR SOMENTE PARA VERIFICAR SE TEM BRINDE NO CARRINHO E REMOVER DO CACHE
		// usebobBrinde.handleRemoveBrindesEmCache();

		// HABILITAR SOMENTE PARA VERIFICAR SE TEM BRINDE NO CARRINHO E REMOVER SE ELE ESTIVER SOZINHO
		// usebobBrinde.handleBrindeEmbalagem();

		// HABILITAR SOMENTE PARA VERIFICAR SE TEM BRINDE NO CARRINHO E REMOVER SE ELE ESTIVER SOZINHO
		// usebobBrinde.handleRemoveBrindesEmSolo();

		// usebobBrinde.handleBarStatusEmbalagem();
	},

	async updateItems(itemsAjustarQuantity) {
		const body = { updates: itemsAjustarQuantity };

		document.dispatchEvent(new CustomEvent("theme:loading:start"));

		const config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
		};

		try {
			const response = await axios.post("/cart/update.js", body, config);
			const data = response.data;

			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: {
						variant: data.items,
						quantity: data.items.length,
					},
				})
			);
		} catch (error) {
			console.log(
				"Erro ao alterar a quantidade dos produtos no carrinho: ",
				error
			);
		}
	},

	async setItemBrinde(itemsAddCart) {
		const body = { items: itemsAddCart };

		document.dispatchEvent(new CustomEvent("theme:loading:start"));

		const config = {
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
		};

		try {
			const response = await axios.post("/cart/add.js", body, config);
			const data = response.data;

			data.items.forEach(function (item) {
				// if(item.quantity > 1) {
				//     setTimeout(function() {
				//         document.querySelector(`#e-usebob-change-${item.id}`).click();
				//     }, 1500);
				// }
			});

			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(
				new CustomEvent("product:added", {
					bubbles: true,
					detail: {
						variant: data.items,
						quantity: data.items.length,
					},
				})
			);
		} catch (error) {
			console.log("Erro ao adicionar o produto no carrinho: ", error);
		}
	},

	setItemBrindeEmbalagem(itemsAjustarQuantity) {
		const body = { updates: itemsAjustarQuantity };

		document.dispatchEvent(new CustomEvent("theme:loading:start"));

		axios
			.post("/cart/update.js", body, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
			})
			.then((response) => response.data)
			.then((data) => {
				document.dispatchEvent(new CustomEvent("theme:loading:end"));
				document.dispatchEvent(
					new CustomEvent("product:added", {
						bubbles: true,
						detail: {
							variant: data.items,
							quantity: data.items.length,
						},
					})
				);
			})
			.catch((error) =>
				console.log(
					"Erro ao alterar a quantidade dos produtos no carrinho: ",
					error
				)
			);
	},

	removeItemBrinde(itemsRemCart) {
		itemsRemCart.forEach(function (item) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(`[href*='/cart/change?quantity=0&id=${item.productId}']`)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
		});
	},

	async init() {
		usebobMinicart.init();
		// console.log("exec brinde recharge");
		await usebobBrinde.getItemsCart();

		// SCRIPT PARA REMOVER BRINDES EM CACHE
		// usebobBrinde.handleRemoveBrindesEmCache();

		await usebobBrinde.handleGift();
	},
};

window.usebobBrinde = usebobBrinde;

var usebobMinicart = {
	cartItems: [],
	qtdaItems: 0,
	totalPrice: 0,

	async getCartItems() {
		try {
			const response = await axios.get(`/cart.js`);
			const data = response.data;

			this.cartItems = data.items;
			this.qtdaItems = data.item_count;
			this.totalPrice = data.total_price;
		} catch (error) {
			console.log(error.message);
		}

		let hasDetox = false;
		let hasGiftDetox = false;

		this.cartItems.forEach(item => {
			if (item.sku == 'SH01-US') {
				hasDetox = true;
			}
			if (item.sku == 'SH01-US-GIFT' && item.properties.root == 'promoDetox') {
				hasGiftDetox = true;
			}
		})

		// if (hasDetox && !hasGiftDetox) {
		//   utils.addToCart(
		//     [
		//       {
		//         id: 41787226620055, quantity: 1, properties: {
		//           root: 'promoDetox'
		//         }
		//       }
		//     ]
		//   )
		// }

		if (hasGiftDetox) {
			this.removeItemBrindeSync([{ variantID: 41787226620055 }])
		}
	},

	async updateCartItems(items) {
		const body = { updates: items };

		const headers = {
			Accept: "application/json",
			"Content-Type": "application/json",
		};

		try {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			const response = await axios.post("/cart/update.js", body, { headers });
			const data = response.data;
			const cartItems = data.items;
			const cartItemsLength = data.items.length;

			const config = {
				bubbles: true,
				detail: {
					variant: cartItems,
					quantity: cartItemsLength,
				},
			};

			document.dispatchEvent(new CustomEvent("theme:loading:end"));
			document.dispatchEvent(new CustomEvent("product:added", config));
		} catch (error) {
			console.log("Erro ao alterar a quantidade dos produtos no carrinho: ");
			console.log(error.message);
		}
	},

	removeItemBrinde(cartItems) {
		cartItems.then((data) => {
			data.forEach(function (item) {
				document.dispatchEvent(new CustomEvent("theme:loading:start"));
				document
					.querySelector(
						`[href*='/cart/change?quantity=0&id=${item.variantID}']`
					)
					.click();
				document.dispatchEvent(new CustomEvent("theme:loading:end"));
			});
		});
	},

	removeItemBrindeSync(cartItems) {
		cartItems.forEach(function (item) {
			document.dispatchEvent(new CustomEvent("theme:loading:start"));
			document
				.querySelector(`[href*='/cart/change?quantity=0&id=${item.variantID}']`)
				.click();
			document.dispatchEvent(new CustomEvent("theme:loading:end"));
		});
	},

	async init() {
		await usebobMinicart.getCartItems();
		await upsellMinicart.init(this.cartItems, this.qtdaItems, this.totalPrice);
	},
};

window.usebobMinicart = usebobMinicart;

window.addEventListener("load", function () {
	usebobBrinde.init();

	// SCRIPT PARA REMOVER BRINDES EM CACHE
	// usebobBrinde.handleRemoveBrindesEmCache();
});

window.addEventListener("changeCupom", function () {
	usebobBrinde.init();
});
